import products from 'app/config/files/products.json';
import { Products } from 'app/models/types/common/ProductsConfig';

export const getCountryPassengerRules = () =>
  (products.country_passenger_rules as Products['country_passenger_rules']);
